import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Play, ChevronRight, Star, Award, Globe, Mic2, ArrowRight, ChevronLeft } from 'lucide-react';
import './Home.css';

// Hero Slider Images — real photos from jimmyzband.com
const heroSlides = [
  {
    img: '/Assets/jimmy-band-jimmy-john-thomas.jpg.jpeg',
    title: 'JIMMY\'Z BAND',
    sub: 'Spreading Melodies Across the World',
    tag: '🏆 Best Versatile Band of Jaipur',
  },
  {
    img: '/Assets/jimmy-band-gaurav-bhatt.jpg.jpeg',
    title: 'LIVE PERFORMANCES',
    sub: 'Bollywood · Sufi · Classical · Folk Fusion',
    tag: '⭐ 4.8/5 Google Rating',
  },
  {
    img: '/Assets/jimmy-band-bhavani-shankar-javda.jpg.jpeg',
    title: 'AWARD WINNING',
    sub: 'Govt. of Rajasthan Awardee · International Performer',
    tag: '🌍 8+ Countries Performed',
  },
  {
    img: '/Assets/jimmy-band-raghvendra-mathur.jpg.jpeg',
    title: 'EVERY EVENT',
    sub: 'Corporate · Weddings · Birthdays · Receptions',
    tag: '🎵 1500+ Shows Performed',
  },
  {
    img: '/Assets/mainslide-04.jpg.jpeg',
    title: 'PINKCITY JAIPUR',
    sub: 'Energetic Music That Leaves Everyone Wanting More',
    tag: '✓ Google Certified Service Provider',
  },
];

const genres = [
  { id: 'bollywood-hits', label: 'Bollywood Hits', img: '/Assets/p1.jpg.jpeg' },
  { id: 'english-retros', label: 'English Retros', img: '/Assets/p2.jpg.jpeg' },
  { id: 'sufi-geet', label: 'Sufi Geet', img: '/Assets/p3.jpg.jpeg' },
  { id: 'ghazals', label: 'Ghazals', img: '/Assets/p4.jpg.jpeg' },
  { id: 'indian-classical', label: 'Indian Classical', img: '/Assets/p5.jpg.jpeg' },
  { id: 'folk-fusion', label: 'Folk Fusion', img: '/Assets/p6.jpg.jpeg' },
];

const services = [
  { img: '/Assets/ai-corporate-events.png',   title: 'Corporate Events',    desc: 'Premium entertainment for corporate occasions — leaving a lasting impression on your team and clients.' },
  { img: '/Assets/ai-birthday-party.png',     title: 'Birthday Parties',    desc: 'Live Band, DJ & Karaoke parties for every age group. Make your birthday truly unforgettable.' },
  { img: '/Assets/ai-anniversary.png',        title: 'Anniversary Parties', desc: 'Surprise your loved one with a live music concert for your special anniversary celebration.' },
  { img: '/Assets/ai-reception.png',          title: 'Receptions',          desc: 'The best live wedding bands for unforgettable wedding receptions in Jaipur and beyond.' },
  { img: '/Assets/ai-wedding-sangeet.png',    title: 'Wedding & Sangeet',   desc: 'Make your wedding and sangeet night magical with electrifying live performances tailored just for you.' },
  { img: '/Assets/ai-family-gathering.png',   title: 'Family Get Together', desc: 'A live band that gets everyone — from kids to grandparents — on the dance floor.' },
  { img: '/Assets/ai-cafe-lounge.png',        title: 'Café / Lounge / Bars', desc: 'We work with venues of all sizes — from local pubs and cafés to upscale restaurants.' },
];

const countries = ['USA (2013, 2016 & 2018)', 'UAE (2013, 2017)', 'Russia (2018)', 'France (2019)', 'Germany (2019)', 'Belgium (2019)', 'Switzerland (2019)', 'Nepal (2008, 2012, 2015)'];

const stats = [
  { num: '1500+', label: 'Shows Performed' },
  { num: '4.8★', label: 'Google Rating' },
  { num: '8+', label: 'Countries' },
  { num: '25+', label: 'Years Experience' },
];

const awards = [
  'Best Versatile Band of Jaipur — 4.8/5 rating',
  'Google Certified Service Provider',
  '4x Certificate of Excellence — Govt. of Rajasthan',
  'Felicitated by NCC 1 Raj Girls Battalion Jaipur',
  'Commendations by Dept. of Archaeology & Museums (2015, 2016, 2018)',
  'Felicitated by IBPC Sharjah, UAE (2017)',
  'Felicitated by Indian Business Alliance (SITA) Moscow (2018)',
  'Grand Orchestra — World Cultural Festival, Art of Living (2016)',
  'Runner-up Zee Aa Se Antakshiri — Zee TV',
  'Awarded by Rotary Club Jaipur',
];

const team = [
  { name: 'Dr Jimmy John Thomas', role: 'Vocalist, Keyboard & Guitar, DJ, Anchor', credentials: 'Sangeet Bhaskar | Sangeet Visharad | MBA', img: '/Assets/jimmy-band-jimmy-john-thomas.jpg.jpeg' },
  { name: 'Gaurav Bhatt', role: 'Vocalist & Guitarist', credentials: 'Sangeet Visharad | Akashwani B-High Grade | Indian Idol', img: '/Assets/jimmy-band-gaurav-bhatt.jpg.jpeg' },
  { name: 'Raghvendra Mathur', role: 'Rhythmist — Drums, Octopad', credentials: '', img: '/Assets/jimmy-band-raghvendra-mathur.jpg.jpeg' },
  { name: 'Bhavani Shankar Javda', role: 'Rhythmist — Drums, Tabla, Dhol, Cajon', credentials: 'Sangeet Visharad | Choreographer', img: '/Assets/jimmy-band-bhavani-shankar-javda.jpg.jpeg' },
];

function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const timerRef = useRef(null);

  const goTo = (idx) => {
    if (animating) return;
    setAnimating(true);
    setCurrent(idx);
    setTimeout(() => setAnimating(false), 700);
  };

  const next = () => goTo((current + 1) % heroSlides.length);
  const prev = () => goTo((current - 1 + heroSlides.length) % heroSlides.length);

  useEffect(() => {
    timerRef.current = setInterval(next, 5000);
    return () => clearInterval(timerRef.current);
  }, [current, next]);

  const slide = heroSlides[current];

  return (
    <section className="hero">
      {/* Slides */}
      <div className="hero-slides">
        {heroSlides.map((s, i) => (
          <div
            key={i}
            className={`hero-slide ${i === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${s.img})` }}
          />
        ))}
        <div className="hero-overlay" />
        <div className="hero-pattern" />
      </div>

      {/* Content */}
      <div className="hero-content container">
        <div className={`hero-text ${animating ? 'slide-exit' : 'slide-enter'}`} key={current}>
          <div className="hero-badge animate-fadeInUp">{slide.tag}</div>
          <h1 className="hero-title animate-fadeInUp delay-1">{slide.title}</h1>
          <p className="hero-sub animate-fadeInUp delay-2">{slide.sub}</p>
          <div className="hero-actions animate-fadeInUp delay-3">
            <Link to="/contact" className="btn-primary">Book Now <ArrowRight size={16} /></Link>
            <a href="https://www.youtube.com/watch?v=jwjZGmhwgLA" target="_blank" rel="noreferrer" className="hero-play">
              <span className="play-ring"><Play size={18} fill="white" /></span>
              Watch Live
            </a>
          </div>
        </div>

        <div className="hero-stats animate-fadeInUp delay-4">
          {stats.map(s => (
            <div key={s.label} className="hero-stat">
              <span className="hero-stat-num">{s.num}</span>
              <span className="hero-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Controls */}
      <button className="hero-arrow hero-arrow-left" onClick={prev}><ChevronLeft size={24} /></button>
      <button className="hero-arrow hero-arrow-right" onClick={next}><ChevronRight size={24} /></button>

      {/* Dots */}
      <div className="hero-dots">
        {heroSlides.map((_, i) => (
          <button key={i} className={`hero-dot ${i === current ? 'active' : ''}`} onClick={() => goTo(i)} />
        ))}
      </div>

      {/* Thumbnails */}
      <div className="hero-thumbs">
        {heroSlides.map((s, i) => (
          <button
            key={i}
            className={`hero-thumb ${i === current ? 'active' : ''}`}
            onClick={() => goTo(i)}
            style={{ backgroundImage: `url(${s.img})` }}
          />
        ))}
      </div>

      <div className="hero-scroll">
        <div className="scroll-line" />
        <span>Scroll</span>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div className="home">
      <HeroSlider />

      {/* GENRES */}
      <section className="genres-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-tag">Repertoire</span>
            <h2 className="section-title">We Perform</h2>
            <div className="center-line" />
          </div>
          <div className="genres-grid">
            {genres.map((g, i) => (
              <Link to={`/genre/${g.id}`} key={g.label} className="genre-card animate-fadeInUp" style={{ animationDelay: `${i * 0.08}s` }}>
                <div className="genre-img-wrap">
                  <img src={g.img} alt={g.label} />
                  <div className="genre-overlay-text">
                    <h3>{g.label}</h3>
                    <div className="genre-line" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ABOUT STRIP */}
      <section className="about-strip">
        <div className="container about-strip-inner">
          <div className="about-strip-text">
            <span className="section-tag">About Us</span>
            <h2 className="section-title">Versatile Live Music Band</h2>
            <div className="red-line" />
            <p>A versatile live music band hailing from Pinkcity Jaipur — spreading its melodies across the world with energetic music that leaves everyone feeling good and wanting for more.</p>
            <p style={{ marginTop: 16 }}>We perform Bollywood Hits, English Retros, Sufi, Ghazals, Indian Classical, Folk Fusion and many more. With over 1500+ shows across India and 8+ countries, we bring the perfect musical experience to every event.</p>
            <Link to="/about" className="btn-primary" style={{ marginTop: 28 }}>Know More <ChevronRight size={16} /></Link>
          </div>
          <div className="about-strip-visual">
            <div className="visual-card main-card">
              <a href="https://www.youtube.com/watch?v=jwjZGmhwgLA" target="_blank" rel="noreferrer" className="yt-thumb">
                <img src="https://img.youtube.com/vi/jwjZGmhwgLA/hqdefault.jpg" alt="Jimmy'z Band Live" />
                <div className="yt-play"><Play size={32} fill="white" /></div>
              </a>
            </div>
            <div className="award-badge-float">
              <Star size={16} fill="var(--gold)" color="var(--gold)" />
              <div>
                <div className="award-num">4.8/5</div>
                <div className="award-label">Google Rating</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="services-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-tag">What We Do</span>
            <h2 className="section-title">Our Specializations</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>Spreading melodies across the world — energetic music that leaves everyone feeling good</p>
            <div className="center-line" />
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <div key={s.title} className="service-card animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="service-img-wrap">
                  <img src={s.img} alt={s.title} />
                  <div className="service-img-overlay" />
                </div>
                <div className="service-content">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <Link to="/contact" className="service-link">Book Now <ArrowRight size={14} /></Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INTERNATIONAL */}
      <section className="intl-section">
        <div className="intl-bg" />
        <div className="container intl-inner">
          <div className="intl-text">
            <span className="section-tag" style={{ color: 'var(--gold)' }}>Global Presence</span>
            <h2 className="section-title" style={{ color: 'white' }}>International Appearances</h2>
            <div className="red-line" />
            <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: 28 }}>We have performed Indian music in various countries:</p>
            <div className="countries-grid">
              {countries.map(c => (
                <div key={c} className="country-item"><Globe size={14} /> {c}</div>
              ))}
            </div>
          </div>
          <div className="intl-cta">
            <div className="cta-box">
              <h3>Make Your Event Memorable!</h3>
              <p>A live band is a surefire way to create an unforgettable experience for your guests.</p>
              <Link to="/contact" className="btn-gold" style={{ marginTop: 24 }}>Contact Now <ArrowRight size={16} /></Link>
            </div>
          </div>
        </div>
      </section>

      {/* AWARDS */}
      <section className="awards-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-tag">Recognition</span>
            <h2 className="section-title">Awards & Achievements</h2>
            <div className="center-line" />
          </div>
          <div className="awards-grid">
            {awards.map((a, i) => (
              <div key={i} className="award-item animate-fadeInUp" style={{ animationDelay: `${i * 0.05}s` }}>
                <Award size={16} className="award-icon" />
                <span>{a}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="team-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-tag">The Artists</span>
            <h2 className="section-title">Our Team</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>Professionals who respect your event and everything it stands for.</p>
            <div className="center-line" />
          </div>
          <div className="team-grid">
            {team.map((m, i) => (
              <div key={m.name} className="team-card card animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="team-img-wrap">
                  <img src={m.img} alt={m.name} onError={e => { e.target.style.display = 'none'; }} />
                  <div className="team-overlay"><Mic2 size={24} /></div>
                </div>
                <div className="team-info">
                  <h3>{m.name}</h3>
                  <p className="team-role">{m.role}</p>
                  {m.credentials && <p className="team-creds">{m.credentials}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="cta-banner">
        <div className="cta-banner-bg" />
        <div className="container cta-banner-inner">
          <div>
            <h2>Relax and Enjoy Our Live Music Concert</h2>
            <p>Music creates atmosphere, influences moods, and makes every event unforgettable.</p>
          </div>
          <Link to="/contact" className="btn-outline">Book Your Event <ArrowRight size={16} /></Link>
        </div>
      </section>
    </div>
  );
}
